import styled from 'styled-components';
import { DefaultTheme } from 'styled-components/dist/types';

const Underline = styled.div<{ color?: keyof DefaultTheme['colors'] }>`
  height: 1px;
  width: 100%;
  align-self: center;
  background-color: ${({ theme, color }) => theme.colors[color || 'black']};
`;

export default Underline;
